<template>
  <div>
    <div class="main" v-if="isPC">
      <div class="page-head">
        <el-breadcrumb separator="<">
          <el-breadcrumb-item class="fontfine" :to="{ path: '/login' }">{{ $t('Home.Certification.AddCertification.Back') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('Home.Certification.AddCertification.ToSignIn') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <section class="bg-white">
        <h2>{{ $t('Home.Certification.AddCertification.CompanyInformation') }}</h2>

        <div class="certificate-tips f">
          <div class="certificate-statu fd-c f--c">
            <img src="@/assets/img/uncertificate.svg" alt="">
            <span>{{ $t('Home.Certification.AddCertification.UNVERIFIEDBUYER') }}</span>
          </div>
          <div class="certificate-info">
            <p style="padding-bottom:15px;"> {{ $t('Home.Certification.AddCertification.Tips1') }}<span class="pointer heretext" @click="$refs.certificateEquipmentDialog.show()">{{ $t('Home.Certification.AddCertification.Tips2') }}</span>.</p>
            <p> *{{ $t('Home.Certification.AddCertification.Tips3') }}</p>
          </div>
        </div>
        <el-form label-position="top" :model="form" :rules="rules" ref="form" label-width="100px">
          <el-row class="fw-w f">
            <el-col :span="8" style="width:32%;margin-right:2%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.FirstName')" prop="first">
                <el-input v-model="form.first" :placeholder="$t('Home.Certification.AddCertification.PleaseEnterContent')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="width:32%;margin-right:2%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.LastName')" prop="last">
                <el-input v-model="form.last" :placeholder="$t('Home.Certification.AddCertification.PleaseEnterContent')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="width:32%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.CompanyName')" prop="companyName">
                <el-input v-model="form.companyName" :placeholder="$t('Home.Certification.AddCertification.PleaseEnterContent')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="width:32%;margin-right:2%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.DoYouSellOnline')" prop="ifSellOnline">
                <el-radio-group v-model="form.ifSellOnline">
                  <el-radio :label="1">{{ $t('Home.Certification.AddCertification.Yes') }}</el-radio>
                  <el-radio :label="0">{{ $t('Home.Certification.AddCertification.No') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="form.ifSellOnline===1"  style="width:32%;margin-right:2%;">
                <el-form-item :label="$t('Home.Certification.AddCertification.StoreURL')" prop="storeUrl" :rules="form.ifSellOnline===1?[{required:true,message:$t('Home.Certification.AddCertification.PleaseEnterYourStoreUrl'),trigger:['change','blur']}]:[]">
                  <el-input v-model="form.storeUrl" :class="{requiredInputPC:form.ifSellOnline===1}"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="width:32%" >
              <el-form-item :label="$t('Home.Certification.AddCertification.SellerPermitNumbe')" prop="sellerPermit" :rules="form.ifSellOnline===0?[{ required: true, message: $t('Home.Certification.AddCertification.PleaseEnterYourSellerPermitNumber'), trigger: ['change', 'blur'] }]:[]">
                <el-input v-model="form.sellerPermit" :placeholder="$t('Home.Certification.AddCertification.PleaseEnterContent')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" style="height:140px;">
              <el-form-item :label="$t('Home.Certification.AddCertification.StorePicture')">
                <div class="storePicture demo-image__preview" v-if="form.storePicture && form.storePicture!==''">
                  <div @click="form.storePicture=''" class="icon pointer">×</div>
                  <el-image fit="contain" style="width: 104px; height: 110px" :src="form.storePicture" :preview-src-list="[form.storePicture]">
                  </el-image>
                </div>
                <el-upload v-else list-type="picture-card" class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :multiple="false" accept="image/*" :before-upload="beforeUpload">
                  <i class="el-icon-circle-plus-outline"></i>
                  <span class="el-upload__text">{{ $t('Home.Certification.AddCertification.Image') }}</span>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <h2>{{ $t('Home.Certification.AddCertification.DocumentOFProof') }}</h2>
              <p class="upload-tip">{{ $t('Home.Certification.AddCertification.DocumentProofOFBusiness') }}</p>
              <p class="upload-tip"> {{ $t('Home.Certification.AddCertification.Tips4') }}<span class="pointer heretext" @click="$refs.certificateEquipmentDialog.show()">{{ $t('Home.Certification.AddCertification.here') }}</span>.</p>
              <div class="f" style="margin:10px 0">
                <div v-for="(item,index) in documentFiles" :key="index" class="upload-demo-box">
                  <div v-if="item.url!==''" class="storePicture f-c-c">
                    <div class="icon pointer" @click="removeDocument(item)">×</div>
                    <img v-if="item.type==='docx'" src="@/assets/img/word.png" alt="">
                    <img v-else-if="item.type==='gif'" src="@/assets/img/GIF.png" alt="">
                    <img v-else-if="item.type==='pdf'" src="@/assets/img/Pdf.png" alt="">
                    <el-image v-else fit="contain" style="width: 104px; height: 110px" :src="item.url" :preview-src-list="[item.url]">
                    </el-image>
                  </div>
                  <el-upload v-else list-type="picture-card" class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :multiple="false" accept=".png,.jpg,.gif,.docx,.pdf" :before-upload="(file)=>uploadUniversalFile(file,item)">
                    <i class="el-icon-document"></i>
                    <div class="el-upload__text"> <i class="iconfont icon-upload-2-line" style="font-size:18px;"></i> {{ $t('Home.Certification.AddCertification.Upload') }}</div>
                  </el-upload>
                </div>
              </div>
              <p class="upload-tip">{{ $t('Home.Certification.AddCertification.UploadFormat') }}：.JPG, .GIF, .DOC OR .PDF ONLY</p>
            </el-col>
          </el-row>
          <h2>{{ $t('Home.Certification.AddCertification.CompanyAddress') }}</h2>
          <el-row class="fw-w f">
            <el-col :span="8" style="width:32%;margin-right:2%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.Address')" prop="address">
                <el-input v-model="form.address" :placeholder="$t('Home.Certification.AddCertification.PleaseEnterContent')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="width:32%;margin-right:2%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.City')" prop="city">
                <el-input v-model="form.city" :placeholder="$t('Home.Certification.AddCertification.PleaseEnterContent')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="width:32%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.StateProvince')" prop="stateOrProvince">
                <el-input v-model="form.stateOrProvince" :placeholder="$t('Home.Certification.AddCertification.PleaseEnterContent')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="width:32%;margin-right:2%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.ZIPPostalCode')" prop="ipOrPostalCode">
                <el-input v-model="form.ipOrPostalCode" :placeholder="$t('Home.Certification.AddCertification.PleaseEnterContent')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="width:32%;margin-right:2%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.Country')" prop="country">
                <el-select v-model="form.country" :placeholder="$t('common.selectContent')" filterable style="width:100%" @change="handleCountryChange" :filter-method="value=> countryFilterMethod(value)">
                  <el-option v-for="item in addressDataFilter" :key="item.countryCode" :label="item.countryNameEn" :value="item.countryNameEn">{{item.countryNameEn}}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="width:32%;">
              <el-form-item :label="$t('Home.Certification.AddCertification.Phone')" prop="phone">
                <el-input v-model="form.phone" :placeholder="$t('common.inputContent')">
                  <el-select v-model="areaCode" filterable slot="prepend" style="color:000;width:100px" @change="handleAreaCodeChange">
                    <el-option v-for="(item,index) in areanolist" :label="item.code" :value="item.code" :key="index">{{item.code}}</el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </section>
    </div>
    <div class="certificate-mobile" v-else>
      <div class="breadcrumb bg-white" @click="$router.go(-1)">
        <i class="el-icon-arrow-left"></i>
        <span>{{ $t('Home.Certification.AddCertification.AddCertification') }}</span>
      </div>
      <div class="certificate-tips_mobile bg-white">
        <div class="certificate-tips_inner">
          <div class="certificate-statu_mobile f--c">
            <img src="@/assets/img/uncertificate.svg" alt="">
            <span>{{ $t('Home.Certification.AddCertification.UNVERIFIEDBUYER') }}</span>
          </div>
          <p style="padding-bottom: 0.2rem;">{{ $t('Home.Certification.AddCertification.Tips1') }} <span class="pointer heretext" @click="$refs.certificateEquipmentDialog.show()">{{ $t('Home.Certification.AddCertification.Tips2') }}</span>.</p>
          <p> {{ $t('Home.Certification.AddCertification.Tips3') }}</p>
        </div>
      </div>
      <div class="base-info_mobile">
        <el-form el-form label-position="top" label-width="80px" :model="form" :hide-required-asterisk="true" ref="form" :rules="rules">
          <div class="form-content_mobile bg-white mg_1">
            <el-form-item prop="first">
              <el-input :placeholder="$t('Home.Certification.AddCertification.FirstName')" v-model="form.first" class="requiredInputMobile mobileInput"></el-input>
            </el-form-item>
          </div>
          <div class="form-content_mobile bg-white mg_1">
            <el-form-item prop="last">
              <el-input :placeholder="$t('Home.Certification.AddCertification.LastName')" v-model="form.last" class="requiredInputMobile mobileInput"></el-input>
            </el-form-item>
          </div>
          <div class="form-content_mobile bg-white mg_1">
            <el-form-item prop="companyName">
              <el-input :placeholder="$t('Home.Certification.AddCertification.CompanyName')" v-model="form.companyName" class="requiredInputMobile mobileInput"></el-input>
            </el-form-item>
          </div>
          <div class="form-content_mobile bg-white mg_2">
            <div class="f-b-c" style="padding:0.28rem 0.32rem 0 0.1rem">
              <span><span style="color:red">*</span> {{ $t('Home.Certification.AddCertification.DoYouSellOnline') }}</span>
              <el-form-item prop="ifSellOnline" >
                <el-radio-group v-model="form.ifSellOnline">
                  <el-radio :label="1">{{ $t('Home.Certification.AddCertification.Yes') }}</el-radio>
                  <el-radio :label="0">{{ $t('Home.Certification.AddCertification.No') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <el-form-item prop="storeUrl" v-show="form.ifSellOnline===1">
              <el-input :placeholder="$t('Home.Certification.AddCertification.StoreURL')" v-model="form.storeUrl" class="mobileInput" :class="[form.ifSellOnline===1?'requiredInputMobile':'']"></el-input>
            </el-form-item>
          </div>
          <div class="form-content_mobile bg-white mg_2">
            <el-form-item prop="sellerPermit" :rules="form.ifSellOnline===0?[{ required: true, message: 'Please enter your seller permit number', trigger: ['change', 'blur'] }]:[]">
              <el-input :placeholder="$t('Home.Certification.AddCertification.SellerPermitNumbe')" v-model="form.sellerPermit" :class="[form.ifSellOnline===0?'requiredInputMobile':'']" class="mobileInput"></el-input>
            </el-form-item>
          </div>
          <div class="bg-white upload-store_img" style="margin-bottom:0.1rem">
            <span>{{ $t('Home.Certification.AddCertification.StorePicture') }}</span>
            <div class="storePicture-mobile demo-image__preview" v-if="form.storePicture && form.storePicture!==''">
              <div @click="form.storePicture=''" class="icon pointer">×</div>
              <el-image fit="contain" style="width: 2.08rem; height: 2.08rem" :src="form.storePicture" :preview-src-list="[form.storePicture]">
              </el-image>
            </div>
            <el-upload v-else list-type="picture-card" class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :multiple="false" accept="image/*" :before-upload="beforeUpload">
              <i class="el-icon-circle-plus-outline"></i>
              <span class="el-upload__text">{{ $t('Home.Certification.AddCertification.Image') }}</span>
            </el-upload>
          </div>
          <div class="bg-white upload-file" style="margin-bottom:0.1rem">
            <h2>{{ $t('Home.Certification.AddCertification.DocumentOFProof') }}</h2>
            <p>{{ $t('Home.Certification.AddCertification.Tips4') }} <span class="pointer heretext" @click="$refs.certificateEquipmentDialog.show()">{{ $t('Home.Certification.AddCertification.here') }}</span>.</p>
            <div class="f" style="margin:10px 0">
              <div v-for="(item,index) in documentFiles" :key="index">
                <div v-if="item.url!==''" class="document-mobile f-c-c">
                  <div class="icon pointer" @click="removeDocument(item)">×</div>
                  <img v-if="item.type==='docx'" src="@/assets/img/word.png" alt="">
                  <img v-else-if="item.type==='gif'" src="@/assets/img/GIF.png" alt="">
                  <img v-else-if="item.type==='pdf'" src="@/assets/img/Pdf.png" alt="">
                  <el-image v-else fit="contain" style="width: 1.5rem; height: 1.6rem" :src="item.url" :preview-src-list="[item.url]">
                  </el-image>
                </div>
                <el-upload v-else list-type="picture-card" class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :multiple="false" accept=".png,.jpg,.gif,.docx,.pdf" :before-upload="(file)=>uploadUniversalFile(file,item)">
                  <i class="el-icon-document"></i>
                  <div class="el-upload__text"> <i class="iconfont icon-upload-2-line" style="font-size:0.32rem;"></i> {{ $t('Home.Certification.AddCertification.Upload') }}</div>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="company-info_mobile">
            <h2 class="bg-white">{{ $t('Home.Certification.AddCertification.CompanyAddress') }}</h2>
            <div class="form-content_mobile bg-white mg_1">
              <el-form-item prop="address">
                <el-input :placeholder="$t('Home.Certification.AddCertification.Address')" v-model="form.address" class="requiredInputMobile mobileInput"></el-input>
              </el-form-item>
            </div>
            <div class="form-content_mobile bg-white mg_1">
              <el-form-item prop="city">
                <el-input :placeholder="$t('Home.Certification.AddCertification.City')" v-model="form.city" class="requiredInputMobile mobileInput"></el-input>
              </el-form-item>
            </div>
            <div class="form-content_mobile bg-white mg_1">
              <el-form-item prop="stateOrProvince">
                <el-input :placeholder="$t('Home.Certification.AddCertification.StateProvince')" v-model="form.stateOrProvince" class=" mobileInput"></el-input>
              </el-form-item>
            </div>
            <div class="form-content_mobile bg-white mg_1">
              <el-form-item prop="ipOrPostalCode">
                <el-input :placeholder="$t('Home.Certification.AddCertification.ZIPPostalCode')" v-model="form.ipOrPostalCode" class=" mobileInput"></el-input>
              </el-form-item>
            </div>
            <div class="form-content_mobile bg-white mg_1">
              <el-form-item prop="country">
                <m-picker v-model="form.country" :visible.sync="countryvisible" :title="$t('Home.Certification.AddCertification.Select')" show-toolbar :columns="addressDataFilter" :custom-field="{value: 'countryNameEn', label: 'countryNameEn'}" @confirm="confirm" />
                <div @click="countryvisible = true">
                  <el-input v-model="form.country" class="requiredInputMobile mobileInput" :readonly="true" :placeholder="$t('address.country')">
                  </el-input>
                </div>
              </el-form-item>
            </div>
            <div class="form-content_mobile bg-white mg_1 phone-box">
              <el-form-item prop="phone">
                <m-picker v-model="areaCode" :visible.sync="visible" :title="$t('Home.Certification.AddCertification.Select')" show-toolbar :columns="areanolist" :custom-field="{value: 'code', label: 'code'}" @confirm="confirmAreaCode" />
                <el-input :placeholder="$t('Home.Certification.AddCertification.Phone')" v-model="form.phone" class="requiredInputMobile mobileInput">
                  <template slot="prepend">
                    <span class="f--c" @click="visible = true" style="font-size:0.32rem;color:#7B7B7B">{{areaCode}}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                      <!-- <i class="required-mark" style="margin-left:0.1rem">*</i> -->
                    </span>
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div v-if="isPC" class="bottomButton f-c-c" :class="[isPC?'bottomButton':'bottomButton-mobile']">
      <el-button @click="jumpHref('/mall')"  style="width: 200px;height: 48px" >{{ $t('Home.Certification.AddCertification.SubmitLater') }}</el-button>
      <el-button type="primary" style="width: 200px;height: 48px" @click="addCertification" :loading="loading">{{ $t('customDetail.Submit') }}</el-button>
    </div>
    <div v-else class="bottomButton f-c-c" :class="[isPC?'bottomButton':'bottomButton-mobile']">
      <el-button @click="jumpHref('/mall')"  style="width: 3.4rem;height:0.8rem" >{{ $t('Home.Certification.AddCertification.SubmitLater') }}</el-button>
      <el-button type="primary" style="width: 3.4rem;height:0.8rem" @click="addCertification" :loading="loading">{{ $t('customDetail.Submit') }}</el-button>
    </div>
    <CertificateEquipmentDialog ref="certificateEquipmentDialog" />
  </div>
</template>

<script>
import API from '@/api'
import areanolist from '@/config/areanolist.js'
import Picker from '@/components/mobile/Picker'
import { telephoneNumber } from '@/util/validate'
import CertificateEquipmentDialog from '../../personal-center/components/CertificateEquipmentDialog.vue'
let checktelephoneNumber = (rules, value, callback) => {
  if (telephoneNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}
export default {
  components: {
    'm-picker': Picker,
    CertificateEquipmentDialog
  },
  data() {
    return {
      addressData: [],
      areanolist: [],
      areaCode: '+1',
      countryvisible: false,
      visible: false,
      form: {},
      rules: {
        first: [{ required: true, message: 'Please enter your first name', trigger: ['change', 'blur'] }],
        ifSellOnline: [{ required: true, message: 'Please select Yes or No', trigger: ['change', 'blur'] }],
        address: [{ required: true, message: 'Please enter your address', trigger: ['change', 'blur'] }],
        last: [{ required: true, message: 'Please enter your last name', trigger: ['change', 'blur'] }],
        companyName: [{ required: true, message: "Please enter your company's name", trigger: ['change', 'blur'] }],
        // sellerPermit: [{ required: true, message: 'Please enter your seller permit number', trigger: ['change', 'blur'] }],
        city: [{ required: true, message: 'Please enter your city', trigger: ['change', 'blur'] }],
        // stateOrProvince: [{ required: true, message: 'Please enter this state or province', trigger: ['change', 'blur'] }],
        // ipOrPostalCode: [{ required: true, message: 'Please enter your postal code', trigger: ['change', 'blur'] }],
        country: [{ required: true, message: 'Please select the country', trigger: ['change', 'blur'] }],
        phone: [{ required: true, validator: checktelephoneNumber, trigger: ['change', 'blur'] }, { max: 20, message: 'Please Enter No More Than 20 Characters' }]
      },
      addressDataFilter: [],
      loading: false,
      imageSignValue: '',
      documentFiles: [
        { url: '', type: '' },
        { url: '', type: '' },
        { url: '', type: '' },
        { url: '', type: '' }
      ]
    }
  },
  created() {
    this.areanolist = areanolist
    this.getAddressInfo()
    localStorage.removeItem('isSeller')
  },
  methods: {
    beforeUpload(file) {
      API.customProductGetSignValue({ directory: 'common/images/' }).then(res => {
        this.imageSignValue = res.data
        let data = new FormData()
        data.append('directory', 'common/images/')
        data.append('signValue', this.imageSignValue)
        data.append('fileList', file)
        API.orderUploadFile(data).then(res => {
          this.$set(this.form, 'storePicture', res.data)
          this.$forceUpdate()
        })
      })
      return false
    },
    uploadUniversalFile(file, item) {
      console.log(file, item)
      API.customProductGetSignValue({ directory: 'common/file/' }).then(res => {
        this.imageSignValue = res.data
        let data = new FormData()
        data.append('directory', 'common/file/')
        data.append('signValue', this.imageSignValue)
        data.append('file', file)
        API.uploadUniversalFile(data).then(res => {
          item.url = res.data
          item.type = file.name.split('.')[file.name.split('.').length - 1]
        })
      })
      return false
    },
    removeDocument(item) {
      item.url = ''
      item.type = ''
      this.$forceUpdate()
    },
    getCountryName(countryCode) {
      let data = [...this.addressData]
      let arr = data.filter(item => item.code === countryCode)
      if (arr.length > 0) { return arr[0].name_en }
    },
    getAddressInfo() {
      API.systemAddressInfo().then(res => {
        this.addressData = res.data
        this.addressDataFilter = res.data.slice()
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },
    confirm(value, row) {
      this.form.country = row.countryNameEn
      const that = this
      setTimeout(() => {
        that.countryFilterMethod('')
      }, 500)
    },
    handleCountryChange() {
      const that = this
      setTimeout(() => {
        that.countryFilterMethod('')
      }, 500)
    },
    confirmAreaCode(value, row) {
      this.areaCode = value
    },
    handleAreaCodeChange(value) {
      this.areaCode = value
    },
    addCertification() {
      if (this.areaCode === '') return this.$message.warning('Please select your area code')
      this.$refs.form.validate(valid => {
        if (!valid) return
        let form = { ...this.form }
        form.userId = this.$store.state.common.userId
        form.documentOfProofUrl = this.documentFiles.map(item => item.url).filter(item => item !== '').toString()
        form.phone = `${this.areaCode}-${this.form.phone}`
        this.loading = true
        API.addCertification(form).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$router.push('/certificate-submiited')
        }).finally(() => {
          this.loading = false
        })
      })
    },
    countryFilterMethod(searchValue) {
      console.log(searchValue)
      if (!searchValue) {
        this.addressDataFilter = this.addressData.slice()
      } else {
        const codeArr = []
        const nameArr = []
        this.addressData.forEach(e => {
          if (e.countryCode.includes(searchValue.toUpperCase())) {
            codeArr.push(e)
          } else if (e.countryNameEn.toUpperCase().includes(searchValue.toUpperCase())) {
            nameArr.push(e)
          }
        })
        this.addressDataFilter = [...codeArr, ...nameArr]
      }
    },
    jumpHref(path) {
      location.href = path
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-input-group__prepend {
  color: #606266;
}
/deep/.el-input-group__prepend {
  background-color: #fff;
  width: 80px;
  border-right: none;
}
.page-head {
  padding-top: 32px;
}
section {
  margin: 22px 0 120px;
  padding: 0 100px 60px;
  h2 {
    font-weight: 500;
    font-size: 18px;
    line-height: 30px;
    color: #000000;
    padding-top: 25px;
  }
}

.certificate-tips {
  margin: 20px 0;
  width: 100%;
  height: 113px;
  border: 0.5px solid #e53238;
  padding: 15px 20px;
  .certificate-statu {
    flex: 3;
    width: 145px;
    margin-right: 28px;
    span {
      display: inline-block;
      padding-top: 10px;
      width: 145px;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #000000;
    }
  }
  .certificate-info {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #000000;
    p a {
      text-decoration: underline;
      color: #000000;
    }
  }
}
.upload-demo-box {
  margin-right: 15px;
}
/deep/.el-input--medium .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 2px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before{
  content: '';
  // color: #F56C6C;
  margin-left: 0px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:after{
  content: '*';
  color: #F56C6C;
  margin-left: 5px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:after, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after{
  content: '*';
  color: #F56C6C;
  margin-left: 5px;
}
/deep/.el-form-item--medium .el-form-item__label {
  line-height: 23px;
  padding-bottom: 5px;
  color: #000000;
}
/deep/.el-upload--picture-card {
  width: 104px;
  height: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 20px;
  margin-right: 15px;
}
.el-icon-upload2 {
  font-size: 16px;
  color: #000000;
}
.el-icon-document {
  font-size: 36px;
  color: #cdd4dd;
  margin-bottom: 5px;
}
.el-upload__text {
  color: #000000;
}
.upload-tip {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #747a87;
  // padding-top: 10px;
}
.bottomButton {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  width: 100%;
  background: #fff;
  z-index: 11;
  box-shadow: 0px -2px 12px 2px rgba(0, 0, 0, 0.06);
}
.bottomButton-mobile {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1.2rem;
  z-index: 11;
  width: 100%;
  background: #fff;
  box-shadow: 0px -2px 12px 2px rgba(0, 0, 0, 0.06);
}
/deep/.el-col .el-col-16 {
  /deep/.el-form-item__content {
    position: relative;
  }
}
.ifSellOnline {
  position: absolute;
  top: -24px;
  left: 150px;
}
.certificate-mobile {
  padding-bottom: 1.6rem;
  .mg_1 {
    margin-bottom: 1px;
  }
  .mg_2 {
    margin-bottom: 2px;
  }
  .breadcrumb {
    padding: 0.2rem 0.1rem;
    .el-icon-arrow-left {
      font-size: 0.3rem;
    }
    > span {
      font-size: 0.3rem;
    }
  }
  .certificate-tips_mobile {
    padding: 0.2rem 0.24rem;
    margin-bottom: 0.2rem;
    .certificate-tips_inner {
      border: 0.5px solid #e53238;
      padding: 0.3rem;
      .certificate-statu_mobile {
        margin-bottom: 0.3rem;
        span {
          display: inline;
          padding-left: 0.16rem;
          font-weight: 400;
          font-size: 0.28rem;
          line-height: 0.42rem;
          color: #000000;
        }
      }
      p {
        font-weight: 400;
        font-size: 0.24rem;
        line-height: 0.36rem;
        color: #000000;
      }
    }
  }
  .base-info_mobile {
    margin-bottom: 2px;
    .form-content_mobile {
      .mobileInput {
        /deep/.el-input__inner {
          border-color: transparent !important;
          border-radius: 0;
          height: 1.2rem;
          line-height: 1.2rem;
        }
        /deep/.el-textarea__inner {
          border-color: transparent !important;
          border-radius: 0;
        }
      }
      .requiredInputMobile::after {
        display: block;
        content: '*';
        position: absolute;
        top: 0.3rem;
        left: 6px;
        color: red;
      }
    }
  }
  /deep/.el-form-item {
    margin-bottom: 0;
  }
  .upload-store_img {
    padding: 0.24rem 0.3rem;
    span {
      font-weight: 400;
      font-size: 0.28rem;
      line-height: 0.42rem;
      color: #000000;
      display: inline-block;
      padding-bottom: 0.2rem;
    }
    /deep/.el-upload--picture-card {
      width: 2.08rem;
      height: 2.08rem;
    }
  }
  .storePicture-mobile {
    width: 2.08rem;
    height: 2.08rem;
    border: 1px dashed #c0ccda;
    position: relative;
    img {
      height: 1.2rem;
      width: 1.2rem;
      object-fit: contain;
    }
  }
  .icon {
    position: absolute;
    width: 23px;
    height: 20px;
    line-height: 16px;
    top: -0px;
    right: 0px;
    text-align: center;
    color: #fff;
    background: rgba(84, 84, 84, 0.6);
    border-radius: 2px 6px 2px 30px;
    z-index: 10;
  }
  .document-mobile {
    width: 1.5rem;
    height: 1.6rem;
    border: 1px dashed #c0ccda;
    position: relative;
    margin-right: 0.2rem;
    img {
      height: 1rem;
      width: 1rem;
      object-fit: contain;
    }
  }
  .icon {
    position: absolute;
    width: 23px;
    height: 20px;
    line-height: 16px;
    top: -0px;
    right: 0px;
    text-align: center;
    color: #fff;
    background: rgba(84, 84, 84, 0.6);
    border-radius: 2px 6px 2px 30px;
    z-index: 10;
  }
  .upload-file {
    padding: 0.24rem 0.3rem;
    h2 {
      font-weight: 500;
      font-size: 0.32rem;
      line-height: 0.48rem;
      color: #000000;
    }
    p {
      font-weight: 400;
      font-size: 0.24rem;
      line-height: 0.36rem;
      color: #747a87;
      margin-bottom: 0.28rem;
    }
    /deep/.el-upload--picture-card {
      width: 1.5rem;
      height: 1.6rem;
    }
    .mg_l {
      margin-right: 0.2rem;
    }
  }
  .upload-demo-box-mpbile {
    margin-right: 0.2rem;
  }
  .company-info_mobile {
    h2 {
      font-weight: 500;
      font-size: 0.32rem;
      line-height: 0.48rem;
      padding: 0.24rem 0 0.4rem 0.4rem !important;
      color: #000000;
      margin-bottom: 1px;
    }
  }
  /deep/.el-input-group__prepend {
    border: none;
    background: #fff;
  }
  .phone-box {
    .requiredInputMobile::after {
      top: 0.5rem !important;
    }
    /deep/.el-input__inner {
      padding-left: 0;
    }
  }
}
.storePicture {
  width: 104px;
  height: 110px;
  border: 1px dashed #c0ccda;
  position: relative;
  img {
    height: 63px;
    width: 63px;
    object-fit: contain;
  }
  .icon {
    position: absolute;
    width: 23px;
    height: 20px;
    line-height: 16px;
    top: -0px;
    right: 0px;
    text-align: center;
    color: #fff;
    background: rgba(84, 84, 84, 0.6);
    border-radius: 2px 6px 2px 30px;
    z-index: 10;
  }
}
.heretext {
  text-decoration: underline;
}
// .requiredInputPC::after {
//   display: block;
//   content: '*';
//   position: absolute;
//   top: 5px;
//   left: 6px;
//   color: red;
// }
</style>
